import { TBilling } from '../../../shared/types/billing.type'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'
import { t } from 'i18next'
import I18nDataGrid from '../../global/I18nDataGrid'
import { Icon } from '@iconify/react'

type BillingsTableProps = {
    billings: TBilling[],
}

function BillingsTable({ billings }: BillingsTableProps) {

    const cols: GridColDef[] = [
        {
            field: 'stripe_id',
            headerName: 'Id',
            flex: 1,
        },
        {
            field: 'billing_email',
            headerName: t('billing:billingEmail'),
            flex: 1,
        },
        {
            field: 'link',
            headerName: t('equimetre:table:link'),
            flex: 1,
            renderCell: (val: GridRenderCellParams<TBilling>) => {
                return <a style={{ display: 'flex', alignItems: 'center', gap: 2 }} href={process.env.REACT_APP_BACKOFFICE_BILLING_URI?.concat(val.row.stripe_id) ?? '#'} rel="noreferrer" target='_blank'>
                    {t('renewalBanner:linkText')}
                    <Icon icon='tabler:external-link' />
                </a>
            }
        },
    ]


    return (
        <I18nDataGrid
            rows={billings}
            columns={cols}
            getRowId={(row: TBilling) => row['@id']}
            disableColumnFilter
            disableColumnMenu
            disableRowSelectionOnClick
        />
    )
}

export default BillingsTable